import UsersTableItem from './UsersTableItem'

export default UsersTableItem
